import { createFileRoute } from '@tanstack/react-router';
import { Lock } from 'lucide-react';
import { z } from 'zod';

import { MessagingInboxPage } from '@/features/messaging/components/inbox-view';
import { useCurrentUserRole } from '@/lib/team';
import { can } from '@simplificalo/contracts/permissions';

const searchSchema = z.object({
  // ?c=<uuid> selecciona la conversación abierta en el panel derecho.
  c: z.string().uuid().optional(),
});

export const Route = createFileRoute('/_app/correo/')({
  validateSearch: searchSchema,
  component: EmailInboxPage,
});

function EmailInboxPage() {
  const role = useCurrentUserRole();
  if (!can(role, 'correo.inbox.view')) {
    return (
      <div
        className="mx-auto flex max-w-md flex-col items-center justify-center gap-3 rounded-lg border py-16 text-center"
        style={{ borderColor: 'var(--color-border)' }}
      >
        <Lock className="h-6 w-6" style={{ color: 'var(--color-fg-subtle)' }} aria-hidden />
        <h2 className="text-base font-semibold" style={{ color: 'var(--color-fg)' }}>
          Acceso restringido
        </h2>
        <p className="text-sm" style={{ color: 'var(--color-fg-muted)' }}>
          No tienes permiso para acceder a Correo.
        </p>
      </div>
    );
  }
  return <MessagingInboxPage mode="email" />;
}
